module.exports = __webpack_public_path__ + "img/Integrated Approach to Conservation.e3be4447.png";